import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=42ef3e82&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupDetail.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef3e82",
  null
  
)

export default component.exports